import { useCallback, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useGetOrganisationTagTypesQuery } from 'src/graphql';
import { setGlobalTagTypes } from 'src/reducers/Tags.slice';

const QUERY_KEY = 'getOrganisationTagTypes';

const useFetchTagTypes = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { data: tagTypes, isLoading: isTagTypesLoading } =
    useGetOrganisationTagTypesQuery(undefined, { queryKey: QUERY_KEY });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries(QUERY_KEY);
  }, [queryClient]);

  useEffect(() => {
    if (tagTypes) {
      dispatch(setGlobalTagTypes(tagTypes.getOrganisationTagTypes));
    }
  }, [dispatch, tagTypes]);

  return {
    invalidateQuery,
    isTagTypesLoading,
  };
};

export default useFetchTagTypes;
